import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

import { Device, RemoteServiceDiagnosisResponse } from '@vi-iot/client';

import { GatewayMainDeviceDetails, RichDevice } from '@store';
import { TrendingCategory } from 'src/app/+installations/installation/trending/trending-chart/trending-chart.helpers';

export namespace DevicesActions {
  export enum Type {
    UPDATE_DEVICES = '[DEVICES] Update devices',
    UPDATE_DEVICES_SUCCESS = '[DEVICES] Update devices success',
    LOAD_DEVICES_SUCCESS = '[DEVICES] Load devices success',
    SET_SELECTED_DEVICE = '[DEVICES] Set selected device',
    SET_SELECTED_DEVICE_BY_ID = '[DEVICES] Set selected device by id',
    SET_SELECTED_DEVICE_WITHOUT_FETCHING_FEATURES = '[DEVICES] Set selected device without fetching features',
    RESET_SELECTED_DEVICE_ID = '[DEVICES] Reset Selected Device id',
    SET_SELECTED_DEVICE_ON_USER_CLICK = '[DEVICES] Set selected device on user click',
    SWITCH_SELECTION_TO_MAIN_DEVICE = '[DEVICES] Switch selection to main device',
    UPDATE_BMU_SERIAL = '[DEVICES] Update BMU Serial',
    UPDATE_BMU_SERIAL_SUCCESS = '[DEVICES] Update BMU Serial Success',
    UPDATE_BMU_SERIAL_ERROR = '[DEVICES] Update BMU Serial Error',
    LOAD_BOILER_SERIAL_DATA = '[DEVICES] Load Boiler Serial Data',
    LOAD_BOILER_SERIAL_DATA_SUCCESS = '[DEVICES] Load Boiler Serial Data Success',
    LOAD_BOILER_SERIAL_DATA_ERROR = '[DEVICES] Load Boiler Serial Data Error',
    LOAD_BOILER_SERIAL_DATA_WHEN_SERIAL_IS_NOT_PRESENT = '[DEVICES] Load Boiler Serial Data When Serial Is Not Present',
    SET_DATA_FOR_WALLBOX_DEVICE = '[DEVICES] Set data for wallbox device',
    SET_WALLBOX_DEVICE_OFFLINE = '[DEVICES] Set wallbox device offline',
    UPDATE_BOILER_SERIAL = '[DEVICES] Update Boiler Serial',
    UPDATE_BOILER_SERIAL_SUCCESS = '[DEVICES] Update Boiler Serial Success',
    UPDATE_BOILER_SERIAL_ERROR = '[DEVICES] Update Boiler Serial Error',
    LOAD_DIAGNOSTIC_DATA_BY_DEVICES = '[DEVICES] Load diagnostic data by devices',
  }

  export const updateDevices = createAction(Type.UPDATE_DEVICES);
  export const updateDevicesSuccess = createAction(
    Type.UPDATE_DEVICES_SUCCESS,
    props<{
      devices: RichDevice[];
    }>()
  );

  export const loadDevicesSuccess = createAction(
    Type.LOAD_DEVICES_SUCCESS,
    props<{
      devices: RichDevice[];
    }>()
  );

  export const setSelectedDevice = createAction(
    Type.SET_SELECTED_DEVICE,
    props<{
      gatewaySerial: string;
      deviceId: string;
      selectId?: string;
    }>()
  );

  export const setSelectedDeviceWithoutFetchingFeatures = createAction(
    Type.SET_SELECTED_DEVICE_WITHOUT_FETCHING_FEATURES,
    props<{
      deviceSelectId?: string;
    }>()
  );

  export const setSelectedDeviceById = createAction(
    Type.SET_SELECTED_DEVICE_BY_ID,
    props<{
      deviceSelectId: string;
    }>()
  );

  export const resetSelectedDeviceId = createAction(Type.RESET_SELECTED_DEVICE_ID);

  export const switchSelectionToMainDevice = createAction(Type.SWITCH_SELECTION_TO_MAIN_DEVICE);

  export const setSelectedDeviceOnUserClick = createAction(
    Type.SET_SELECTED_DEVICE_ON_USER_CLICK,
    props<{
      gatewaySerial: string;
      deviceId: string;
      selectId: string;
    }>()
  );

  export const updateBmuSerial = createAction(
    Type.UPDATE_BMU_SERIAL,
    props<{ bmuSerial: string }>()
  );

  export const updateBmuSerialSuccess = createAction(
    Type.UPDATE_BMU_SERIAL_SUCCESS,
    props<{ installationId: number; bmuSerial: string }>()
  );

  export const updateBmuSerialError = createAction(
    Type.UPDATE_BMU_SERIAL_ERROR,
    props<{ error: any }>()
  );

  export const loadMaterialDataWhenSerialIsNotPresent = createAction(
    Type.LOAD_BOILER_SERIAL_DATA_WHEN_SERIAL_IS_NOT_PRESENT,
    props<{ device: Device }>()
  );

  export const loadMaterialDataWhenSerialIsPresent = createAction(
    Type.LOAD_BOILER_SERIAL_DATA,
    props<{ serialNumber: string; device: Device }>()
  );

  export const loadBoilerSerialDataSuccess = createAction(
    Type.LOAD_BOILER_SERIAL_DATA_SUCCESS,
    props<{ mainDevicesDetails: GatewayMainDeviceDetails }>()
  );

  export const loadBoilerSerialDataError = createAction(
    Type.LOAD_BOILER_SERIAL_DATA_ERROR,
    props<{
      error: any;
    }>()
  );

  export const updateBoilerSerial = createAction(
    Type.UPDATE_BOILER_SERIAL,
    props<{ boilerSerial: string }>()
  );

  export const updateBoilerSerialSuccess = createAction(
    Type.UPDATE_BOILER_SERIAL_SUCCESS,
    props<{ installationId: number; boilerSerial: string }>()
  );

  export const updateBoilerSerialError = createAction(Type.UPDATE_BOILER_SERIAL_ERROR);

  export const loadDiagnosticDataByDevices = createActionGroup({
    source: Type.LOAD_DIAGNOSTIC_DATA_BY_DEVICES,
    events: {
      attempt: emptyProps(),
      success: props<{
        diagnosticDataArray: RemoteServiceDiagnosisResponse[];
      }>(),
      error: emptyProps(),
    },
  });

  export const loadBatteryModuleCategories = createActionGroup({
    source: '[INSTALLATION FEATURES] update battery has largest modules',
    events: {
      attempt: emptyProps(),
      success: props<{
        batteryModuleCategories: TrendingCategory[];
      }>(),
      error: emptyProps(),
    },
  });
}
